export default __webpack_public_path__ + "static/media/dashboard-button-ads.24d36103.png";